<template>
  <div class="home">
    <div class="banner">
      <video width="100%" id="video" autoplay="" loop="" preload="" muted="" x-webkit-airplay="true" airplay="allow" webkit-playsinline="true" playsinline="true" src="/home-video.mp4"></video>
      <div class="banner-text">
        <div :class="$t('lang') === 'En' ? 'en':'zh'">{{$t('slogan')}}</div>
        <!-- <div class="zh">全双工卫星通信：光缕双生，星地同吟</div>
        <div class="en">Full-Duplex Satellite Communication: Twin Light Strands, Celestial Harmony</div> -->
      </div>
      
    </div>
    <div class="lab">
      <div class="lab-top">
        <div class="lab-top-img-box">
          <img src="../assets/home/lab-img2.png" alt="">
        </div>
        <div class="lab-top-des-box">
          <div class="lab-top-title">
            {{$t('home_lab_title')}}
          </div>
          <div class="lab-top-des">
            {{$t('home_lab_des1')}}
          </div>
          <div class="lab-top-des">
            {{$t('home_lab_des2')}}
          </div>
        </div>
      </div>
      <!-- <div class="lab-bottom">
        <div class="lab-bottom-des-box">
          {{$t('home_lab_des2')}}
        </div>
        <div class="lab-bottom-img-box">
          <img src="../assets/home/lab-img2.png" alt="">
        </div>
      </div> -->
    </div>
    <div class="research-directions">
      <img class="study-img" src="../assets/home/study.png" alt="">
      <img class="study-bg" src="../assets/home/bg.png" alt="">
      <div class="section-title" :class="$t('lang') === 'En' ? 'en':'zh'">{{ $t('home_directions') }}</div>
      <div class="direction-item" v-for="(direction, index) in researchDirections" :key="index">
        <div class="direction-item-left">
          <div class="direction-title" :class="$t('lang') === 'En' ? 'en':'zh'">{{ direction.title }}</div>
          <div class="direction-details">
            <div v-for="(detail, detailIndex) in direction.details" :key="detailIndex">
              <span>·</span>
              {{ detail }}
            </div>
          </div>
        </div>
        <div style="text-align:right">
          <img :src="direction.image" :alt="direction.title">
        </div>
      </div>
    </div>
    <!-- <div class="current-leadership">
      <div class="section-title">{{ $t('current_leadership') }}</div>
      <div class="leader-item-container">
        <div class="leader-item" v-for="(leader, index) in leaders" :key="index">
          <img :src="leader.image" :alt="leader.name">
          <div>
            <div class="leader-name">{{ leader.name }}</div>
            <p>{{ leader.position }}</p>
            <div class="moreBtn" @click="showPopup(index)">{{ $t('find_more') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isPopupVisible" class="popup-container">
      <div class="popup-content">
        <div class="closeBtn" @click="hidePopup">
          <img src="../assets/close.png" alt="">
        </div>
        <div class="pop-line"></div>
        <div class="pop-name">{{leaders[curIndex].name}}</div>
        <div class="pop-position">{{leaders[curIndex].position}}</div>
        <div class="pop-des">{{leaders[curIndex].des}}</div>
      </div>
    </div> -->
    <div class="news-box">
      <div class="section-title">{{ $t('news_center') }}</div>
      <div class="news-container">
        <div class="news-right">
          <div class="news-img-box">
            <img :src="require(`../assets/news/news2.png`)" alt="" @click="goDetail(news[0].id)">
            <div class="news-date">{{news[0].date}}</div>
          </div>
          <div class="news-info">
            <div class="news-title">{{ news[0].title }}</div>
            <!-- <div class="news-description">{{ news[0].description }}</div> -->
          </div>
        </div>
        <div class="news-right">
          <div class="news-right1">
            <div class="news-img-box">
              <img :src="require(`../assets/news/news1.png`)" alt="" @click="goDetail(news[1].id)">
              <div class="news-date">{{news[1].date}}</div>
            </div>
            <div class="news-title">{{ news[1].title }}</div>
          </div>
          <!-- <div class="news-right2">
            <div class="news-img-box">
              <img :src="require(`../assets/news/news3.png`)" alt="" @click="goDetail(news[2].id)">
              <div class="news-date">{{news[2].date}}</div>
            </div>
            <div class="news-title">{{ news[2].title }}</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import yjfxImg1 from '../assets/home/yjfx-img1.png'
import yjfxImg2 from '../assets/home/yjfx-img2.png'
import yjfxImg3 from '../assets/home/yjfx-img3.png'
import yjfxImg4 from '../assets/home/yjfx-img4.png'
import leader1 from '../assets/home/leader1.png'
import leader2 from '../assets/home/leader2.png'
export default {
  name: 'App',
  data() {
    return {
      researchDirections: [
        {
          title: this.$t('home_directions1.title'),
          details: [
            this.$t('home_directions1.details1'),
            this.$t('home_directions1.details2'),
            this.$t('home_directions1.details3'),
            this.$t('home_directions1.details4'),
          ],
          image: yjfxImg1
        },
        {
          title: this.$t('home_directions2.title'),
          details: [
            this.$t('home_directions2.details1'),
            this.$t('home_directions2.details2'),
            this.$t('home_directions2.details3'),
            this.$t('home_directions2.details4'),
          ],
          image: yjfxImg2
        },
        {
          title: this.$t('home_directions3.title'),
          details: [
            this.$t('home_directions3.details1'),
            this.$t('home_directions3.details2'),
            this.$t('home_directions3.details3'),
            this.$t('home_directions3.details4'),
          ],
          image: yjfxImg3
        },
        {
          title: this.$t('home_directions4.title'),
          details: [
            this.$t('home_directions4.details1'),
            this.$t('home_directions4.details2'),
            this.$t('home_directions4.details3'),
            this.$t('home_directions4.details4'),
          ],
          image: yjfxImg4
        }
      ],
      leaders: [
        {
          name: this.$t('leader1.name'),
          image: leader1,
          position: this.$t('leader1.position'),
          des:this.$t('leader1.des')
        },
        {
          name: this.$t('leader2.name'),
          image:leader2,
          position: this.$t('leader2.position'),
          des:this.$t('leader2.des')
        }
      ],
      showInfo: {},
      isPopupVisible:false,
      curIndex: 0,
      news: [
        {
          id:2,
          date: "2023.09.15",
          title:this.$t('news2.title'),
          description: this.$t('news2.des1')
        },
        {
          id:1,
          date: "2024.04.14",
          title:this.$t('news1.title'),
          description: this.$t('news1.des1')
        },
        {
          id:3,
          date: "2017.09.20",
          title:this.$t('news3.title'),
          description: ""
        }
      ]
    };
  },
  methods: {
    showPopup(index) {
      this.curIndex = index
      this.isPopupVisible = true;
    },
    hidePopup() {
      this.isPopupVisible = false
    },
    goDetail(id) {
      this.$router.push('/news/detail?id=' + id)
    }
  }
}
</script>
<style scoped lang="scss">
.home {
  color: #FEFEFE;
  overflow-x: hidden;
}
.banner {
  width: 100%;
  position: relative;
  height: 100vh;
  margin: 0 -9vw;
  width: calc(100% + 18vw);
  background: url("../assets/home/banner.png") center/cover no-repeat;
  background-position: center; /* 图片居中显示 */
  overflow: hidden;
  video {
    position: absolute;
    width: auto;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%) scale(1.26);
    z-index: 1;
  }
  .banner-text {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10;
    .zh {
      font-weight: 300;
      font-size: 60px;
      color: #FEFEFE;
    }
    .en {
      font-size: 54px;
      color: #FEFEFE;
      line-height: 40px;
      font-weight: 400;
      width: 100%;
      text-align: center;
      font-family: Calibri;
      margin-top: 45px;
    }
  }
}
.lab {
  margin-top: 100px;
  .lab-top {
    display: flex;
    .lab-top-img-box {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img {
      width: 60%;
    }
    .lab-top-title {
      font-size: 36px;
      line-height: 36px;
      margin-bottom: 40px;
    }
    .lab-top-des-box {
      width: 50%;
      font-weight: 400;
      font-size: 17px;
      color: #FEFEFE;
      line-height: 40px;
      padding-left: 8%;
      display: flex;
      flex-direction: column;
      .lab-top-des {
        text-indent: 2em;
      }
    }
  }
  .lab-bottom {
    display: flex;
    margin-top: 130px;
    .lab-bottom-des-box {
      width: 50%;
      font-weight: 400;
      font-size: 17px;
      color: #FEFEFE;
      line-height: 40px;
      text-indent: 2em;
    }
    .lab-bottom-img-box {
      width: 50%;
      text-align: right;
      img {
        width: 60%;
        padding-right: 8%;
      }
    }
  }
}
.section-title {
  font-weight: 500;
  font-size: 60px;
  color: #FFFFFF;
  padding: 100px 0;
  text-align: center;
  &.en {
    font-size: 54px;
  }
}
.research-directions {
  color: #FFFFFF;
  position: relative;
  margin: 0 -9vw;
  padding: 0 9vw;
  padding-bottom: 300px;
  .study-img {
    position: absolute;
    top: 27%;
    left: 10vw;
    width: 72%;
    z-index: 1;
  }
  .study-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 0;
    width: 100%;
  }
  .direction-item-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .direction-item {
    display: flex;
    margin-bottom: 60px;
    z-index: 10;
    position: relative;
    > div {
      width: 50%;
      img {
        width: 90%;
      }
    }
  }
  .direction-details {
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 36px;
    span {
      font-weight: 700;
      margin-right: 10px;
      // font-size: 36px;
    }
  }
  .direction-title {
    font-weight: 400;
    font-size: 50px;
    margin-bottom: 35px;
    &.en {
      font-size: 44px;
    }
  }
}
.current-leadership {
  background: #FFFFFF;
  margin: 0 -9vw;
  color: #333333;
  padding-bottom: 160px;
  .section-title {
    color: #333333;
  }
  .leader-item-container {
    padding: 0 9vw;
    display: flex;
  }
  .leader-item {
    width: 50%;
    display: flex;
    img {
      width: 200px;
      margin-right: 32px;
    }
    > div{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 3% 0;
      .leader-name {
        font-size: 30px;
        color: #333333;
        line-height: 1;
        font-weight: 500;
      }
      p{
        font-weight: 400;
        font-size: 16px;
        line-height: 1;
      }
      .moreBtn {
        width: 114px;
        height: 36px;
        background: #063793;
        border-radius: 18px;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  .popup-content {
    width: 798px;
    background: #000000;
    border-radius: 20px;
    padding: 0 40px 0 80px;
    box-sizing: border-box;
    line-height: 1;
    .closeBtn {
      height: 95px;
      text-align: right;
      cursor: pointer;
      img {
        width: 28px;
        margin-top: 33px;
      }
    }
    .pop-line {
      width: 42px;
      height: 12px;
      background: #FFFFFF;
      border-radius: 6px;
    }
    .pop-name {
      font-weight: 500;
      font-size: 30px;
      margin-top: 26px;
    }
    .pop-position {
      margin-top: 26px;
      font-weight: 400;
      font-size: 16px;
    }
    .pop-des {
      margin-top: 50px;
      font-weight: 400;
      font-size: 16px;
      padding-bottom: 50px;
      line-height: 30px;
      text-indent: 2em;
    }
  }
}
.news-box {
  background: url("../assets/home/bg1.png");
  margin: 0 -9vw;
  padding: 0 10vw;
  background-size: 100% 100%;
  .news-container {
    display: flex;
    align-items: flex-start;
    padding-bottom: 120px;
    img {
      cursor: pointer;
    }
    .news-info {

    }
    .news-right {
      flex: 1;
      min-width: 0;
      margin-right: 60px;
      img {
        width: 100%;
      }
      .news-title {
        font-size: 20px;
        color: #FFFFFF;
        margin: 40px 0;
        width: 100%;
        white-space: nowrap;      /* 禁止换行 */
        overflow: hidden;         /* 溢出内容隐藏 */
        text-overflow: ellipsis;  /* 溢出时显示省略号 */
      }
    }
    .news-left {
      flex: 1;
      margin-right: 6%;
      img {
        width: 100%;
      }
      .news-title {
        font-size: 32px;
        color: #FFFFFF;
        margin: 70px 0;
      }
      .news-description {
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4; /* 限制行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        text-indent: 2em;
      }
    }
    .news-img-box {
      position: relative;
      .news-date {
        position: absolute;
        left: 0;
        bottom: -10px;
        width: 120px;
        height: 40px;
        background: #004DA9;
        font-weight: bold;
        font-size: 17px;
        color: #FEFEFE;
        font-style: italic;
        line-height: 40px;
        text-align: center;
      }
    }
  }
  .section-title {
    text-align: left;
  }
}
</style>
